if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor () {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.onSubmitHandlerBound = this.onSubmitHandler.bind(this);
        this.onSellingPlanSeletedHandlerBound = this.onSellingPlanSeletedHandler.bind(this);
        this.onChangeHandlerBound = this.onChangeHandler.bind(this);

        this.form.addEventListener('submit', this.onSubmitHandlerBound);
        this.showPrice = this.hasAttribute('data-show-price');
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      connectedCallback () {
        if (this.showPrice) {
          this.productInfo = this.closest('product-info');
          this.formID = this.form.getAttribute('id');
          if (!this.productInfo || !this.formID) {
            return;
          }
          this.quantityObject = document.querySelector(`input[name="quantity"][form="${this.formID}"]`);
          this.quantity = this.quantityObject?.value ? this.quantityObject.value : "1";
          this.productURL = this.productInfo.dataset.url;
          this.sectionID = this.productInfo.sectionId;
          this.variantID = this.form?.id?.value;
          this.sellingPlanID = this.form?.selling_plan?.value ?? null;
          document.addEventListener(
            'AppstleSubscription:SubscriptionWidget:SellingPlanSelected',
            this.onSellingPlanSeletedHandlerBound
          );
          this.form.addEventListener('change', this.onChangeHandlerBound);
          /* Skio: el hidden selling_plan está fuera del <form> (atributo form=) — el change no burbujea al form */
          this.sellingPlanInput = document.querySelector(`input[name="selling_plan"][form="${this.formID}"]`);
          if (this.sellingPlanInput) {
            this.sellingPlanInput.addEventListener('change', this.onChangeHandlerBound);
          }
        }
      }

      disconnectedCallback () {
        if (this.showPrice) {
          this.productInfo = null;
          this.formID = null;
          this.quantityObject = null;
          this.quantity = 1;
          this.productURL = null;
          this.sectionID = null;
          this.variantID = null;
          this.sellingPlanID = null;
          document.removeEventListener(
            'AppstleSubscription:SubscriptionWidget:SellingPlanSelected',
            this.onSellingPlanSeletedHandlerBound
          );
          this.form.removeEventListener('change', this.onChangeHandlerBound);
          if (this.sellingPlanInput) {
            this.sellingPlanInput.removeEventListener('change', this.onChangeHandlerBound);
            this.sellingPlanInput = null;
          }
        }
      }

      onSellingPlanSeletedHandler () {
        if(!this.sellingPlanID) {
          this.form.dispatchEvent(new Event('change'));
        }
      }

      onChangeHandler () {
        if (!this.sectionID || !this.productURL) {
          return;
        }
        const quantity = this.quantityObject?.value ? this.quantityObject.value : "1";
        const variantID = this.form.id.value;
        const sellingPlanID = this.form?.selling_plan?.value ?? null;
        let needleRefresh = (quantity !== this.quantity || variantID !== this.variantID || sellingPlanID !== this.sellingPlanID);
        if (!needleRefresh) {
          return;
        }
        const url = new URL(`https://${window.location.host}`);
        url.searchParams.set('variant', variantID);
        url.searchParams.set('section_id', this.sectionID);
        url.searchParams.set('quantity', quantity);
        url.searchParams.set('type', Date.now());
        if (sellingPlanID) {
          url.searchParams.set('selling_plan', sellingPlanID);
        }
        const result = this.productURL + '?' + url.searchParams.toString();
        this.renderProductPrice({
          requestUrl: result,
          callback: (res) => {
            this.variantID = variantID;
            this.sellingPlanID = sellingPlanID;
            this.quantity = quantity;
            const button = res.querySelector(`#${this.formID} button[name="add"]`);
            if (button) {
              this.form.add.innerHTML = button.innerHTML;
            }
          },
        });
      }

      renderProductPrice ({ requestUrl, callback }) {
        this.abortController?.abort();
        this.abortController = new AbortController();

        fetch(requestUrl, { signal: this.abortController.signal }).
          then((response) => response.text()).
          then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            callback(html);
          }).
          then(() => {
          }).
          catch((error) => {
            if (error.name === 'AbortError') {
              console.log('Fetch aborted by user');
            } else {
              console.error(error);
            }
          });
      }

      onSubmitHandler (evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id),
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config).then((response) => response.json()).then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              errors: response.errors || response.description,
              message: response.message,
            });
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButtonText.classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error)
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              cartData: response,
            });
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener(
              'modalClosed',
              () => {
                setTimeout(() => {
                  this.cart.renderContents(response);
                });
              },
              { once: true },
            );
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        }).catch((e) => {
          console.error(e);
        }).finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading__spinner').classList.add('hidden');
        });
      }

      handleErrorMessage (errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton (disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput () {
        return this.form.querySelector('[name=id]');
      }
    },
  );
}
